(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  const seen = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (!motion.matches) entry.target.classList.add('bb-image-reveal');
    });
  }, { threshold: 0.08 });
  const setup = (root = document) => {
    if (motion.matches) return;
    root.querySelectorAll('.bb-photo:not(.bb-hero-photo) img, .bb-product-image img, .bb-photo-slide img').forEach(img => {
      if (seen.has(img)) return;
      seen.add(img);
      const watch = () => { if (img.naturalWidth && !motion.matches) observer.observe(img); };
      if (img.complete) watch();
      else img.addEventListener('load', watch, { once: true });
    });
  };
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  motion.addEventListener('change', () => {
    if (motion.matches) observer.disconnect();
    else setup();
  });
})();
